import * as types from './mutation-types'
import { convertIntToBoolean } from '@/helpers'

export default {
  [types.SET_SETTING] (state, payload) {
    if (payload) {
      state.setting = payload
      convertIntToBoolean(payload, ['address_undefined', 'local_undefined'])
    }
    state.setting = { ...state.setting, ...payload }
  },
  [types.SET_STATUSLIST] (state, payload) {
    state.statusList = payload
  }
}
